import { makeUserPreferencesHooks } from '@eigtech/ui-shared-user'
import type { UnwrapPartial } from 'type-fest'
import { GlobalPreferences, UserPreferences } from '../../types/UserPreferences'
import { preferencesUi } from './constants'

const defaultGlobalPreferences = {} satisfies GlobalPreferences

const defaultUserPreferences = {
  collapsedNav: false,

  claimsColumns: {},
  claimsColumnsExcludedValues: {},
  claimsColumnsOrder: [],
  claimsFilters: [],
  claimsPagination: { pageIndex: 0, pageSize: 10 },
  claimsPinnedColumns: {},
  claimsSorting: [],
} satisfies UserPreferences

export const preferences = makeUserPreferencesHooks<
  UnwrapPartial<UserPreferences>,
  UnwrapPartial<GlobalPreferences>
>({
  preferencesUi,
  globalKeys: Object.keys(defaultGlobalPreferences) as (keyof GlobalPreferences)[],
  defaultGlobalPreferences,
  userKeys: Object.keys(defaultUserPreferences) as (keyof UserPreferences)[],
  defaultUserPreferences,
})
